import React from 'react';
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AppProvider, useAppContext } from './context/AppContext';
import { captureTrackingData } from "./utils/tracking";
import AuthPage from './pages/AuthPage';
import QuestionaryPage from './pages/Questionary';
import theme from './theme';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { state } = useAppContext();
  
  return state.isAuthenticated ? children : <Navigate to="/auth" replace />;
};

// Public Route Component (redirect if authenticated)
const PublicRoute = ({ children }) => {
  const { state } = useAppContext();
  
  return !state.isAuthenticated ? children : <Navigate to="/questionary" replace />;
};

// Main App Component
const AppRoutes = () => {
  
  useEffect(() => {
    captureTrackingData();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/auth" 
          element={
            <PublicRoute>
              <AuthPage />
            </PublicRoute>
          } 
        />
        
        {/* Protected Routes */}
        <Route 
          path="/questionary" 
          element={
            <ProtectedRoute>
              <QuestionaryPage />
            </ProtectedRoute>
          } 
        />
        
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/auth" replace />} />
        <Route path="*" element={<Navigate to="/auth" replace />} />
      </Routes>
    </Router>
  );
};

// Root App Component
const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </ThemeProvider>
  );
};

export default App;

